import React, { useEffect } from "react";
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import T from "../styles/tokens";
import { PFLogo } from "../components/UI";

export default function AuthGate({ children }) {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length > 0 && !instance.getActiveAccount()) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [instance, accounts]);

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginScreen onLogin={() => instance.loginRedirect(loginRequest)} />
      </UnauthenticatedTemplate>
    </>
  );
}

function LoginScreen({ onLogin }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: T.gray100,
        fontFamily: T.font,
        padding: 24,
      }}
    >
      <div
        style={{
          background: T.white,
          padding: "40px 48px",
          borderRadius: 8,
          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
          textAlign: "center",
          maxWidth: 420,
          width: "100%",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
          <PFLogo size={48} />
        </div>
        <h1
          style={{
            margin: 0,
            fontSize: 22,
            fontWeight: 700,
            color: T.indigo,
            marginBottom: 6,
          }}
        >
          Pathfinder Onboarding
        </h1>
        <p style={{ color: "rgba(0,0,0,0.55)", fontSize: 13, marginBottom: 28 }}>
          Sign in with your Pathfinder Microsoft 365 account to continue.
        </p>
        <button
          onClick={onLogin}
          style={{
            background: T.indigo,
            color: T.white,
            border: "none",
            borderRadius: T.radiusSm,
            padding: "12px 24px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: T.font,
            width: "100%",
          }}
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
